module.exports = __webpack_public_path__ + "static/level-8-card.084cf9c5.png";